{
  "nl": {
    "aiFeedback": {
      "confirm": {
        "deleteFeedback": {
          "text": "Deze actie kan niet ongedaan worden gemaakt. De feedback wordt samen met alle bijbehorende resultaten verwijderd.",
          "title": "Feedback verwijderen?"
        },
        "deleteResult": {
          "text": "Deze actie kan niet ongedaan worden gemaakt. Het resultaat wordt samen met de bijbehorende feedback permanent verwijderd.",
          "title": "Resultaat verwijderen?"
        }
      },
      "criteria": {
        "contentAccuracy": "Het onderwerp wordt op een manier uitgewerkt die past bij de vraagstelling en bevat inhoudelijk correcte cijfers, gegevens en feiten over het onderwerp.",
        "spellingAndGrammar": "De spelling, woordvorming en zinsbouw zijn grammaticaal correct. Inhoudswoorden, functiewoorden, complexe uitdrukkingen en vaktermen worden treffend gebruikt.",
        "structureAndOrganization": "De tekst laat een totaalidee zien dat past bij het onderwerp, is logisch opgebouwd en heeft een duidelijke interne/externe structuur, bijvoorbeeld door alinea's."
      },
      "deprecationAlert": {
        "title": "Deze tool is standaard verborgen",
        "description": "Het kan op verzoek op schoolniveau worden geactiveerd.",
        "learnMoreLink": "Meer informatie"
      },
      "unlockedAlert": {
        "title": "Deze tool is geactiveerd voor jouw school",
        "description": "Het wordt niet verder ontwikkeld, maar blijft bruikbaar voor jouw school.",
        "learnMoreLink": "Meer informatie"
      },
      "defaults": {
        "name": "Nieuwe correctie"
      },
      "emptyState": {
        "heading": "Geen correcties aanwezig",
        "text": "Maak een nieuwe correctie door de originele tekst in te voegen en de criteria vast te stellen."
      },
      "flash": {
        "feedbackResultUpdated": "Feedback bijgewerkt",
        "feedbackUpdated": "Criteria bijgewerkt",
        "textExtractionSuccess": "Tekstextractie succesvol"
      },
      "headings": {
        "feedback": "Correctievoorstel",
        "form": "Criteria vaststellen",
        "goodToKnow": "Goed om te weten",
        "input": "Originele tekst",
        "text": "Tekst invoeren"
      },
      "hints": {
        "dropFileImage": "Sleep een afbeelding met tekstinhoud eenvoudig hierheen of",
        "dropFilePdf": "Sleep een PDF hierheen of",
        "experimental": "De correctiehulp-tool genereert AI-gebaseerde <strong>voorstellen voor een voorcorrectie</strong> van leerlingprestaties. Om de voorstellen verantwoord te interpreteren en te gebruiken, moeten de aanbevolen <strong>randvoorwaarden en beperkingen van de AI</strong> absoluut worden gelezen en in acht worden genomen. <a href='https://app.fobizz.com/de/help/articles/249-korrekturhilfe-tool-ki' target='_blank'>Meer informatie</a>",
        "fileLimit": "max {size}MB, {types}",
        "imageRecognitionInProgress": "Beeldherkenning bezig...",
        "pdfRecognitionInProgress": "Tekstextractie bezig..."
      },
      "info": {
        "result": {
          "heading": "Goed om te weten:",
          "text": "De antwoorden van de AI moeten worden opgevat als <strong>voorstellen</strong>.\nZe kunnen nooit een gefundeerde didactische beoordeling van\nleerlingprestaties vervangen."
        }
      },
      "infoMessages": {
        "criteria": "Stel criteria vast op basis waarvan de AI feedback moet geven. Hoe preciezer je de criteria formuleert, hoe nauwkeuriger de feedback."
      },
      "labels": {
        "addCriteria": "Criterium toevoegen",
        "assignment": "Taakomschrijving",
        "criteria": "Beoordelingscriteria",
        "input": "Originele tekst",
        "inputMethod": "Invoermethode",
        "name": "Afkorting (geen echte naam), bijv. leerjaar plus nummer van de klassenlijst",
        "solution": "Verwachtingshorizon of modeloplossing"
      },
      "links": {
        "evaluateText": "Tekst corrigeren",
        "new": "Nieuwe correctie",
        "pastAssessments": "Eerdere correcties",
        "useFile": "Tekst uit afbeelding gebruiken",
        "usePdf": "Tekst uit PDF gebruiken",
        "useText": "Originele tekst invoegen"
      },
      "modals": {
        "confirm": {
          "helpLink": "https://app.fobizz.com/de/help/articles/249-korrekturhilfe-tool-ki",
          "text": "De correctiehulp-tool genereert AI-gebaseerde <strong>voorstellen voor een voorcorrectie</strong> van leerlingprestaties. Om de voorstellen verantwoord te interpreteren en te gebruiken, moeten de aanbevolen <strong>randvoorwaarden en beperkingen van de AI</strong> absoluut worden gelezen en in acht worden genomen.",
          "title": "Instructies voor het gebruik van de correctiehulp-tool"
        }
      },
      "paragraphs": {
        "create": "Bespaar kostbare tijd bij het corrigeren met AI-ondersteunde foutcorrectie en beoordelingsvoorstellen.",
        "goodToKnow": "De antwoorden van de AI moeten worden opgevat als <strong>voorstellen</strong>. Ze kunnen nooit een gefundeerde didactische beoordeling van leerlingprestaties vervangen."
      },
      "placeholders": {
        "assignment": "Schrijf een kort opstel over de belangrijkste oorzaken en historische gebeurtenissen van de Franse Revolutie.",
        "input": "Tekst hier invoegen...",
        "name": "4c-17",
        "solution": "Modeloplossing:\nFranse Revolutie De F. R. van 1789 wordt beschouwd als een van de belangrijkste politiek-sociale keerpunten in de Europese geschiedenis. Ze schafte de absolutistische heerschappij en de voorrechten van adel en kerk af en stelde daarvoor in de plaats de burgerlijke stand. Oorzaak voor de F. R. waren diepgaande sociale en economische wantoestanden (hongersnoden, betalingsonmacht van de staat). Dragend element van de F. R. was de Franse Nationale Vergadering, die in 1789 de Verklaring van de Rechten van de Mens en de Burger (Déclaration des droits de l’homme et du citoyen) aannam. In 1793 werden de doelen van de F. R. samengevat in de eis voor vrijheid, gelijkheid, broederschap (Liberté, Égalité, Fraternité) en werd het een leus die ver buiten FRA werd gedragen en in bijna alle Europese staten gevolgen had. Het verbod op de leus in de Pruisische Rijnprovincies werkt tot op heden na in de burgerlijke carnaval en het magische getal ELF (Égalité, Liberté, Fraternité), dat niet verboden kon worden: Waarom zou de opstand van de narren (= burgers) anders altijd op 11.11. om 11 uur 11 beginnen?\nBron: Schubert, Klaus/Martina Klein: Het Politiek Lexicon. 7e, geactualiseerde en uitgebreide druk. Bonn: Dietz 2020. Licentie-uitgave Bonn: Federale Centrale voor Politieke Vorming."
      },
      "sampleText": "Yo, gast! De Franse Revolutie was zo'n heftige tijd, die duurde van 1789 tot 1799. De mensen waren de adel en de koning helemaal zat, die alleen maar aan het chillen waren terwijl het volk honger leed. Dus zeiden ze: \"Nu is het genoeg, man!\" en hebben ze de koning en de adel eruit gegooid. Dat was het einde van de monarchie en het begin van de eerste Republiek in Frankrijk. Maar het was niet allemaal cool, er was ook veel bloedvergieten, vooral tijdens de zogenaamde \"Reign of Terror\". Maar uiteindelijk heeft deze revolutie de wereld veranderd en ideeën zoals vrijheid, gelijkheid en broederschap verspreid. Heel bizar, toch?"
    }
  }
}
